
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import { Select, MenuItem, FormControl } from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import BlockIcon from '@mui/icons-material/Block';
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import Tooltip from '@mui/material/Tooltip';
import { CircularProgress, Backdrop } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE, VENDOR } from "constants.js";
import configurationContext from "contextConfig";
import { useMaterialUIController, setVendorContext } from "context";

function ManageVendors() {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [vendorData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { vendorContext } = controller;
  const [responseResultCount, setResponseResultCount] = useState(0);
  const MyContext = useContext(configurationContext);
  var pageSelected = 1;
  const { pageNo } = useParams();
  const [isVendorContextChanged, setVendorContextChanged] = useState(false);

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const changeStatus = async (id, status) => {
    toast.dismiss();
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/vendor/updateStatus/" + id + "/" + status,
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          if (vendorData.data.rows) {
            const tempNewRows = vendorData.data.rows;
            for (const key2 in tempNewRows) {
              if (tempNewRows[key2]['id'] == id) {
                const newVendorData = vendorData;
                setData(prevState => {
                  const updatedUserStatus = prevState.data.rows.map(item => {
                    if (item.id === id) {
                      return { ...item, status: (item.status == VENDOR.ACTIVE) ? VENDOR.BLOCKED : VENDOR.ACTIVE };
                    }
                    return item;
                  })
                  return {
                    ...prevState,
                    data: {
                      ...prevState.data,
                      rows: updatedUserStatus
                    }
                  };
                });
              }
            }
          }
          toast.success(t(message));
        }
        else {
          toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/vendor/list?pageSelected=" + pageSelected + "&statusFilter=" + vendorContext.statusFilter + "&orderBy=" + vendorContext.orderBy + "&orderValue=" + vendorContext.orderValue + "&searchBy=" + vendorContext.searchBy + "&searchValue=" + vendorContext.searchValue,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    })
      .then(function (response) {
        setIsLoading(false);
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setResponseResultCount(response.data.data.totalCount)
            setData(response.data);
          }
          else {
            toast.error(t(message))
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const handleResetFilters = () => {
    setVendorContext(dispatch, initialState.vendorContext);
    setVendorContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/vendor/list/page-1");
    else
      navigate("/vendor/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(vendorContext).some(
      key => vendorContext[key] !== initialState.vendorContext[key]
    );
    setVendorContextChanged(hasChanged);
  }, [vendorContext]);

  const columns = [
    { Header: t("id"), accessor: "id", align: "left" },
    { Header: t("name"), accessor: "name", align: "left" },
    { Header: t("email"), accessor: "email", align: "left" },
    { Header: t("mobileNumber"), accessor: "mobileNumber", align: "left" },
    { Header: t("status"), accessor: "status", align: "left" },
    { Header: t("registration"), accessor: "registerType", align: "left" },
    { Header: t("shop name"), accessor: "shopName", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];

  const finalObj = [];

  for (const key in vendorData.data) {
    if (vendorData.data.hasOwnProperty(key)) {
      let dataObj = vendorData.data[key];
      for (const key1 in dataObj) {
        let dataRow = dataObj[key1];
        if (dataRow.id > 0) {
          let tempObj = {
            id: dataRow.id, name: dataRow.name, email: dataRow.email, mobileNumber: (dataRow.mobileNumber) ? dataRow.mobileNumber : ' - ',
            status: (dataRow.status == VENDOR.ACTIVE) ? t('active') : (dataRow.status == VENDOR.BLOCKED) ? t('blocked') : (dataRow.status == VENDOR.PENDING) ? "Email not confirmed" : null,
            registerType: (dataRow.registerType == 1) ? t('Normal Login') : t('Social Login'),
            shopName: dataRow.shopName,
            action:
              <span className="actionLinksStyle">
                {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("vendor", "read"))) ?
                  <MDTypography component="a" href={"#"} onClick={(event) => { event.preventDefault(); navigate("/vendor/edit/" + dataRow.id) }} variant="caption" color="text" fontWeight="medium">
                    <Tooltip title={t('edit')} className="ActionEdit paddingRight5"><Box className="ActionEdit"><EditIcon /></Box></Tooltip>
                  </MDTypography>
                  :
                  null
                }
                {
                  (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("vendor", "write"))) ?
                    <MDTypography component="a" onClick={() => changeStatus(dataRow.id, (dataRow.status == VENDOR.ACTIVE) ? VENDOR.BLOCKED : VENDOR.ACTIVE)}>
                      {(dataRow.status == VENDOR.ACTIVE) ?
                        <Tooltip title={t('block')} className="ActionBlock paddingRight5"><Box className="ActionBlock"><BlockIcon /></Box></Tooltip>
                        :
                        <Tooltip title={t('activate')} className="ActionActive paddingRight5"><Box className="ActionActive"><DoneIcon /></Box></Tooltip>
                      }
                    </MDTypography>
                    :
                    null
                }
              </span>
          };
          finalObj.push(tempObj);
        }
      }
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("Manage Vendors")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {(Object.keys(vendorData).length > 0) ?
        <MDBox pt={6} pb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox className="ManageVendorsTopSec" mx={2}
                  mt={0}
                  py={3}
                  px={2}
                  variant="gradient">
                  <Grid container className="FilterSectionBox" spacing={2} >
                    <Grid item xs={12} sm={2} md={2} >
                      <MDInput
                        select
                        name="statusFilter"
                        className="ManageProductTopSecip"
                        label={t('Status')}
                        value={vendorContext.statusFilter}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        onChange={(obj) => {
                          setVendorContext(dispatch, { ...vendorContext, statusFilter: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value='all'>{t('all')}</MenuItem>
                        <MenuItem value={'Active'}>{t('active')}</MenuItem>
                        <MenuItem value={'Blocked'}>{t('blocked')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="searchBy"
                        label={t('searchBy')}
                        value={vendorContext.searchBy}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        onChange={(obj) => {
                          if (obj.target.value == 'none') {
                            setVendorContext(dispatch, { ...vendorContext, searchValue: '', searchBy: obj.target.value });
                          }
                          else
                            setVendorContext(dispatch, { ...vendorContext, searchBy: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'none'}>{t('None')}</MenuItem>
                        <MenuItem value={'id'}>{t('id')}</MenuItem>
                        <MenuItem value={'name'}>{t('name')}</MenuItem>
                        <MenuItem value={'email'}>{t('email')}</MenuItem>
                        <MenuItem value={'mobileNumber'}>{t('mobileNumber')}</MenuItem>
                        <MenuItem value={'shopName'}>{t('Shop Name')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <FormControl >
                        <MDInput
                          key={'searchValue'}
                          value={vendorContext.searchValue}
                          disabled={(vendorContext.searchBy == 'none') ? true : false}
                          type="text" name="searchValue" label={t("searchInput")}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(obj) => {
                            setVendorContext(dispatch, { ...vendorContext, searchValue: obj.target.value });
                          }}
                          fullWidth />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="Sort By"
                        value={vendorContext.orderBy}
                        label={t('orderBy')}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        onChange={(obj) => {
                          setVendorContext(dispatch, { ...vendorContext, orderBy: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'id'}>{t('id')}</MenuItem>
                        <MenuItem value={'name'}>{t('name')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={isVendorContextChanged ? 1 : 2} md={isVendorContextChanged ? 1 : 2}>
                      <MDInput
                        select
                        name="orderBy"
                        value={vendorContext.orderValue}
                        label={t('order')}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        onChange={(obj) => {
                          setVendorContext(dispatch, { ...vendorContext, orderValue: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                        <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={isVendorContextChanged ? 3 : 2} md={isVendorContextChanged ? 3 : 2}>
                      <FormControl className="filterSubmit">
                        <MDButton
                          onClick={() => {
                            navigate("/vendor/list");
                            if (typeof pageNo === "undefined")
                              data()
                          }}
                          key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple fullWidth> {t('Submit')} </MDButton>
                        {isVendorContextChanged && (
                          <MDButton onClick={handleResetFilters} key="reser" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    showTotalEntries={true}
                    responseResultCount={responseResultCount}
                    paginationSize={MyContext.paginationSize}
                    paginationLink={"/vendor/list/page-"}
                    pageSelected={pageSelected}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ManageVendors;
